<p-dialog #dialog [(visible)]="visible" [resizable]="true" [modal]="false" [style]="{ width: deviceManager.isMobile ? '80vw' : '30vw', height: '70vh' }" position="right"
          (onHide)="onDialogHiding()" (onResizeEnd)="onDialogMoved($event)" (onDragEnd)="onDialogMoved($event)">
    <ng-template pTemplate="header">
        <span class="text-xl font-bold">myCAMPapp AI Assistant</span>
    </ng-template>
    <div *ngIf="aiResponses.length > 0" #responseArea class="ai-response-area">
        <div *ngFor="let queryResponse of aiResponses" class="ai-query-response">
            <div class="ai-queries">
                <div *ngFor="let query of queryResponse.Queries" class="ai-query">{{query}}</div>
            </div>
            <div class="ai-responses">
                <div *ngFor="let response of queryResponse.Responses; let i = index" [class]="'response-' + queryResponse.QueryId + '-' + i"></div>
            </div>
            <div class="ai-response-buttons">
                <p-button icon="pi pi-thumbs-up" styleClass="p-button-text" (click)="onRateResponse(queryResponse.QueryId, 1)"></p-button>
                <p-button icon="pi pi-thumbs-down" styleClass="p-button-text" (click)="onRateResponse(queryResponse.QueryId, -1)"></p-button>
            </div>
        </div>
    </div>
    <ng-template pTemplate="footer">
        <input type="text" pInputText [(ngModel)]="aiQuery" (keydown.enter)="onSendAIQuery()" placeholder="Type your question here" />
        <button pButton type="button" label="Send" icon="pi pi-send" (click)="onSendAIQuery()" [disabled]="aiQuery == null || aiQuery.length === 0"></button>
        <!--        <p-button icon="pi pi-check" (click)="visible = false" label="Ok" styleClass="p-button-text"></p-button>-->
    </ng-template>

    <mycampapp-waiting-indicator *ngIf="busy" [@fadeInOut] ></mycampapp-waiting-indicator>
</p-dialog>

